import { IApplicationState } from '../../types/redux';

export function selectBlackFridayTopPromoSubtitle(state: IApplicationState) {
  return state.blackFriday.topPromoSubtitle;
}
